/**
 * Third-party license notices for in-app display (GPL/LGPL/MPL compliance).
 * Derived from the project NOTICE file. Keep in sync when NOTICE is updated.
 */

export const THIRD_PARTY_NOTICES = [
  {
    name: 'SCOWL (Spell Checker Oriented Word Lists)',
    description: 'English vocabulary (en_US) via spylls',
    copyright: 'Kevin Atkinson (2000-2018)',
    license: 'Permissive; use, copy, modify, distribute and sell allowed; copyright notice must appear in all copies and supporting documentation.',
    sourceUrl: 'https://github.com/en-wl/wordlist',
    licenseUrl: 'https://github.com/en-wl/wordlist',
  },
  {
    name: 'LibreOffice dictionaries — French (fr_FR)',
    description: 'fr_FR/fr.aff, fr_FR/fr.dic',
    copyright: 'Olivier R. (https://grammalecte.net/)',
    license: 'Mozilla Public License 2.0',
    sourceUrl: 'https://github.com/LibreOffice/dictionaries',
    licenseUrl: 'https://www.mozilla.org/MPL/2.0/',
  },
  {
    name: 'LibreOffice dictionaries — Greek (el_GR)',
    description: 'el_GR/el_GR.aff, el_GR/el_GR.dic',
    copyright: 'Steve Stavropoulos, Evripidis Papakostas, contributors',
    license: 'MPL 1.1 / GPL 2.0 / LGPL 2.1 (at your option)',
    sourceUrl: 'https://github.com/LibreOffice/dictionaries',
    licenseUrl: 'https://github.com/LibreOffice/dictionaries/blob/master/el_GR/README_el_GR.txt',
  },
  {
    name: 'spylls (Hunspell in Python)',
    description: 'Hunspell dictionary handling',
    copyright: 'Victor Shepelev (zverok.offline@gmail.com)',
    license: 'Mozilla Public License 2.0',
    sourceUrl: 'https://github.com/zverok/spylls',
    licenseUrl: 'https://www.mozilla.org/MPL/2.0/',
  },
];
